import { Disable } from "app/pages/industry-analysis/overview/widgets/high-level-metrics/single/chartFiltersAndLegends/styled";
import { Legends as LegendsComponent } from "app/components/React/Legends/Legends";
import { PopSingleModeLegends } from "app/pages/website-analysis/TrafficAndEngagement/Legends/PopSingleModeLegends";
import { FlexRow } from "app/pages/website-analysis/website-content/leading-folders/components/Tab";

import { useHighLevelMetricsContext } from "../context";

export const Legends = () => {
    const { legendItems, setLegendItems, isPeriodOverPeriod, params } = useHighLevelMetricsContext();

    if (isPeriodOverPeriod) {
        const { webSource } = params;
        const legendsProps = { webSource, legendItems };
        return (
            <FlexRow>
                <PopSingleModeLegends {...legendsProps} />
            </FlexRow>
        );
    }
    const toggleSeries = (clickedItem) => {
        const newLegendItems = legendItems.map((legendItem) => {
            if (legendItem.name === clickedItem.name) {
                legendItem.visible = !clickedItem.visible;
            }
            return legendItem;
        });
        setLegendItems(newLegendItems);
    };
    const enrichedLegendItems = legendItems.map((legendItem) => {
        const { name, isDisabled } = legendItem;
        const displayName = isDisabled ? <Disable>{name}</Disable> : name;
        return { ...legendItem, name: displayName };
    });
    const legendsProps = { legendItems: enrichedLegendItems, toggleSeries };
    return <LegendsComponent {...legendsProps} />;
};
